import * as React from "react";
import { connect } from "react-redux";
import { StudentTagFilterInterface } from "../../domains/StudentTag";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import { useOnMainScrollAreaScroll } from "../../hooks/useMainScrollAreaScroll";
import OperatorInterface from "../../interfaces/OperatorInterface";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsOperators from "./SectionsSettingsOperators";
import { useFetchOperators } from "./useFetchOperators";

interface Props extends OutletContextProps {
  section: SectionInterface;
  tagFilter: StudentTagFilterInterface;
  currentOperator: OperatorInterface;
}

const actions = {};

const SectionsSettingsOperatorsPage = (props: Props) => {
  React.useEffect(() => {
    props.setActiveMenu("staff");
  }, []);

  const operatorsQuery = useFetchOperators({ sectionId: props.section.id });
  useQueryError(operatorsQuery.error);

  useOnMainScrollAreaScroll(() => {
    if (operatorsQuery.hasNextPage && !operatorsQuery.isFetching) {
      operatorsQuery.fetchNextPage();
    }
  }, [operatorsQuery.hasNextPage, operatorsQuery.isFetching]);

  if (!props.section) {
    return null;
  }

  return (
    <SectionsSettingsOperators
      section={props.section}
      currentOperator={props.currentOperator}
      sectionTags={props.tagFilter.tags}
      isLoading={operatorsQuery.isPending || operatorsQuery.isFetchingNextPage}
      activeOperators={operatorsQuery.activeOperators}
      invitingOperators={operatorsQuery.invitingOperators}
    />
  );
};

const pageInfo = {
  title: "スタッフ一覧",
};

const EnhancedPage = enhanceSectionsSettingsPage(
  SectionsSettingsOperatorsPage,
  pageInfo,
  ["current_section_operator:index"],
);

export default connect(null, actions)(EnhancedPage as any);
